import { BasePage } from '@/components/ui/base-page'

export function QuantitativePage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add QuantitativePage specific content here */}
    </BasePage>
  )
}